<template>
  <NotificationText v-bind="$props">
    <template #primary>
      <i>{{notification.data.senderName}}</i> hat dich in den Raum
      <i>{{notification.data.roomName}}</i> eingeladen.
    </template>
    <template #detail-content>
      <p class="mb-0">
        Der Einladungs-Link ist nur einmalig und für maximal 14 Tage gültig.<br>
        Nachdem du einem Raum beigetreten bist, kannst du diesen auch jederzeit wieder verlassen.<br>
        Falls du nicht beitreten möchtest kannst du diese Nachricht löschen.
      </p>
    </template>
    <template #actions-prepend>
      <v-btn
        small
        text
        color="accent"
        :to="relativeURL(notification.data.invitationUrl)"
        @click="markRead"
      >Einladung ansehen</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import NotificationTextMixin from '../notification-text-mixin';


  export default {
    name: 'RoomInvitation',

    mixins: [
      NotificationTextMixin
    ]
  };
</script>

<style scoped>
  p {
    font-size: 80%;
  }
</style>
